import StarFilled32 from '@carbon/icons-react/es/star--filled/32';
import { Empty } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Rating as RatingT } from 'api/reports/csat';
import { Rate } from 'components/atoms/rate';
import { ProductiveHeading02 } from 'components/styles';
import { Widget } from '../widget';

const Rating = styled.div`
  ${ProductiveHeading02};
  padding: var(--spacing-05);
`;

interface Props {
  data?: RatingT[];
  isLoading?: boolean;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 184px;
  width: 100%;
  flex-direction: column;
`;

export const OverallRating: FC<Props> = (props) => {
  const { data = [], isLoading } = props;
  const sumOfMaximumPossibleStars =
    data
      .map((d) => d.count)
      .reduce((sum, next) => {
        return sum + next;
      }, 0) * 5;

  const numberOfStarsGiven = data
    .map((d) => d.count * d.rating)
    .reduce((sum, next) => sum + next, 0);

  let score = (numberOfStarsGiven / sumOfMaximumPossibleStars) * 5;

  score = Number.isInteger(score) ? score : Number(score.toFixed(1));

  return (
    <Widget
      loading={isLoading}
      title={<FormattedMessage id="csat.widget.heading.overall" />}
    >
      {data.length > 0 ? (
        <Container>
          <Rating>{score || 0}</Rating>
          <Rate character={<StarFilled32 />} disabled value={score} />
        </Container>
      ) : (
        <Empty />
      )}
    </Widget>
  );
};
